export enum DataTypes {
  DATE = "date",
  LINK = "link",
  STRING = "string",
}
